<template>
  <van-popup v-model="show" get-container="body" :close-on-click-overlay="false">
    <div class="cardInfo">
      <div class="header">
        <div class="header-content">
          <Avatar class="avatar" :size="25" :src="cardInfo.Avatar"></Avatar>
          <div class="van-ellipsis">
            <p class="text-big-more van-ellipsis">{{cardInfo.Name}}</p>
            <p class="text-small van-ellipsis">{{cardInfo.DepartmentName}} - {{cardInfo.PositionName}}</p>
          </div>
        </div>
        <van-icon class="close" name="close" size="20" @click="close"/>
      </div>
      <div class="content">
        <div class="card-item">
          <p class="text-big">{{cardInfo.EnterpriseName}}</p>
          <div>
            <span class="text-small text-gray">所属行业: </span>
            <template v-if="cardInfo.Industry && cardInfo.Industry.length" >
              <span class="text-small text-gray" v-for="(subitem,index) in cardInfo.Industry" :key="subitem.IndustryTagId">{{index === cardInfo.Industry.length-1? subitem.IndustryTagName :`${subitem.IndustryTagName}/`}}</span>
            </template>
            <template v-else>
              <span class="text-small text-gray">-</span>
            </template>    
          </div>          
        </div>
        <div class="card-item">
          <div class="card-content-item">
            <label for="地址">地址</label>
            <p>{{cardInfo.ProvinceName?`${cardInfo.ProvinceName}-${cardInfo.CityName}-${cardInfo.DistrictName}-${cardInfo.Address}`:'-'}}</p>              
          </div>
          <div class="card-content-item">
            <label for="传真">传真</label>
            <p>{{cardInfo.Fax | empty-str}}</p>              
          </div>
          <div class="card-content-item">
            <label for="座机">座机</label>
            <p>{{cardInfo.Landline | empty-str}}</p>              
          </div>
          <div class="card-content-item">
            <label for="网址">网址</label>
            <p>{{cardInfo.Website | empty-str}}</p>              
          </div>
        </div>
        <div class="card-item">
          <div class="card-content-item">
            <label for="手机">手机</label>
            <p>{{cardInfo.ContactInfo.MobilePhone | empty-str}}</p>              
          </div>
          <div class="card-content-item">
            <label for="邮箱">邮箱</label>
            <p>{{cardInfo.ContactInfo.Email | empty-str}}</p>              
          </div>
          <div class="card-content-item">
            <label for="QQ">QQ</label>
            <p>{{cardInfo.ContactInfo.QQ | empty-str}}</p>              
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import Avatar from '@/components/avatar'
  import { Cms } from '@/api'
  export default {
    name: 'card', 
    props: {
      show: {
        type: Boolean,
        required: true
      },
      userId: {
        type: Number,
        required: true
      },
      type: {
        type: String,
        // follow fans
        default: 'follow'
      }
    },
    components: {Avatar},
    data() {
      return{
        cardInfo: {
          ContactInfo: {}
        },
        urlMap: {
          follow: Cms.GetFollowedUserCard,
          fans: Cms.UserCardGetFollowUserCard
        }
      }
    },
    watch: {
      show(val) {
        if (val) {
          this.getCardInfo()
        }
      }
    },
    methods: {
      async getCardInfo() {
        let url = this.urlMap[this.type]
        this.cardInfo = await this.$api(url, { FollowUserId: this.userId })
      },
      close() {
        this.$emit('update:show', false)
      }
    }
  };
</script>
<style lang='scss' scoped>
.cardInfo {
  width: 330px;
  height: 400px;
  overflow-y: scroll;
  overflow: auto;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 330px;
    height: 104px;
    background: rgba(43, 50, 63, 1);
    color: #fff;

    &-content {
      overflow: hidden;
      display: flex;
      align-items: center;
      padding: 0 30px;

      .avatar {
        width: 46px;
        height: 46px;
        margin-right: 20px;
        flex: none;
      }
    }
    .close {
      align-self: flex-start;
      flex: none;
      padding: 10px;
    }
  }
  .content {
    padding: 0 26px;
    .card-item {
      padding: 20px 0;
      border-bottom: 1px solid $gray;
    }
    .card-content-item {
      display: flex;
      font-size: $font-size-small;
      label {
        flex: none;
        min-width: 40px;
      }
      p {
        margin-top: 0;
        margin-left: 20px;
        word-break: break-all;
      }
    }
  }
}
</style>